<template>
  <!-- ==== CONTAINER POPUP MAIS EMOLUMENTOS === -->
  <div class="popup" :style="{ top: popupVisible ? '0' : '-100%' }">
    <div class="popup-content">

          <v-dialog
      v-model="$store.state.verdialogoemolumento"
      persistent
      max-width="650px"
    >
       <v-card class="rounded-lg elevation-5">
    <v-card-title class="primary white--text pa-4">
      <span class="text-h5 font-weight-bold">Cadastro de Produto</span>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeModal">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pa-6">
      <v-container fluid class="pa-0">
        <!-- Seção de Informações Básicas -->
        <v-row dense class="mb-2">
          <v-col cols="12">
            <v-text-field
              v-model="produto.descricao"
              label="Descrição do Produto"
              outlined
              clearable
              prepend-inner-icon="mdi-tag"
              :rules="[rules.required]"
              required
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- Seção de Valores -->
        <v-row dense class="mb-1">
          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="produto.preco"
              label="Preço Unitário"
              outlined
              prefix="Kz"
              type="number"
              prepend-inner-icon="mdi-currency-usd"
              :rules="[rules.required, rules.positive]"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="produto.qtd"
              label="Quantidade"
              outlined
              type="number"
              min="1"
              prepend-inner-icon="mdi-package-variant"
              :rules="[rules.required, rules.positive]"
              required
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- Seção de IVA -->
        <v-row align="center" class="mb-2">
          <v-col cols="12" md="6">
            <v-switch
              v-model="produto.temIVA"
              label="Incluir IVA (14%)"
              inset
              color="primary"
              hide-details
            ></v-switch>
          </v-col>

          <v-col cols="12" md="6">
            <v-card outlined class="pa-3" color="grey lighten-4">
              <div class="d-flex justify-space-between align-center">
                <span class="subtitle-1">Preço Final:</span>
                <span class="title primary--text font-weight-bold">
                  Kz {{ utilitarios.IntegerToMoneyValueFatura(precoFinal.toFixed(2)) }}
                </span>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Detalhes do IVA -->
        <v-row v-if="produto.temIVA" class="mt-0">
          <v-col cols="12">
            <v-card outlined class="pa-3" color="grey lighten-5">
              <div class="d-flex justify-space-between align-center">
                <span class="body-1">Valor do IVA (14%):</span>
                <span class="body-1 font-weight-bold">
                  Kz {{ utilitarios.IntegerToMoneyValueFatura((precoFinal - precoSemIva(precoFinal)).toFixed(2)) }}
                </span>
              </div>
              <div class="d-flex justify-space-between align-center mt-2">
                <span class="body-1">Valor sem IVA:</span>
                <span class="body-1">
                  Kz {{ utilitarios.IntegerToMoneyValueFatura(precoSemIva(precoFinal).toFixed(2)) }}
                </span>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Nota de campos obrigatórios -->
        <v-row class="mt-4">
          <v-col cols="12">
            <span class="caption grey--text">* Campos obrigatórios</span>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions class="pa-4 grey lighten-4">
      <v-spacer></v-spacer>
      <v-btn
        color="grey darken-2"
        text
        @click="closeModal"
        class="mr-2"
      >
        Cancelar
      </v-btn>
      <v-btn
        color="primary"
        dark
        @click="salvarProduto"
        :disabled="!formValido"
        depressed
        :loading="overlay"
      >
         Salvar Produto
      </v-btn>
    </v-card-actions>
  </v-card>
    </v-dialog>

    </div>
  </div>
  <!-- ==== FIM CONTAINER POPUP MAIS EMOLUMENTOS === -->
</template>

<script>
import utilitarios from "../../../plugins/utilitarios";
import axios from "../../../plugins/axios";
import Swal from "sweetalert2";
const ls = require("local-storage");
export default {
  data() {
    return {
      valid: true,
      validMulta: true,
      tabelaCamposColor: [],
      validoConfirmacao: true,
      ruleRequired: [(value) => !!value || "campo obrigatorio"],
      ruleNumberNObrigatorioStartWithOne: [
        (value) => {
          const pattern = /^[0-9]+([,.][0-9]+)?$/g;
          return pattern.test(value) || "O valor deve ser numerico.";
        },
      ],
      emolumentos: [],
      searchInDb: "",    
      overlay: false,    
      utilitarios: utilitarios,
      produto: {
        descricao: '',
        preco: null,
        temIVA: false,
        qtd:1
      },
      Defaultproduto: {
        descricao: '',
        preco: null,
        temIVA: false,
        qtd:1
      },
       rules: {
      required: value => !!value || 'Campo obrigatório',
      positive: value => value > 0 || 'Valor deve ser positivo'
    },
      utilitarios: utilitarios
    };
  },

   

  computed:{

     formValido() {
    return this.produto.descricao && this.produto.preco > 0 && this.produto.qtd > 0
  },

    precoFinal() {
      if (!this.produto.preco) return 0;
      return this.produto.temIVA
        ? (this.produto.preco*this.produto.qtd) * 1.14
        : this.produto.preco*this.produto.qtd;
    },
    
  valorIVA() {
    if (!this.produto.preco || !this.produto.temIVA) return 0;
    return this.produto.preco * 0.14;
  },

 

  
  },

  props: {
    popupVisible: Boolean,
    cliente: Object,
  },

  created() {
      
    
  },

  methods: {

     precoSemIva(valorFinal, taxaIva = 14) {

      if(this.produto.temIVA)
           var precoBase = valorFinal / (1 + taxaIva / 100);
      else
         precoBase = 0;
    return precoBase;
  },
     
    async salvarProduto() {
      // lógica para salvar o produto
          try {            
               this.overlay = true
              let params = {produto:this.produto,precoFinal: this.precoFinal.toFixed(2), valorIVA: (this.precoFinal - this.precoSemIva(this.precoFinal)).toFixed(2), precoSemIva:this.produto.preco, nif:this.cliente.bi }
             
              let response = await axios.post('addProduto',{params}).then((res)=>res.data)
               this.produto = this.Defaultproduto
              this.$store.dispatch('toggleNovoEmolumento', false);
              this.$emit("carregarPagamentos");
             
          } catch (error) {
             Swal.fire('Informação','Erro ao Adicionar o produto','error')
          }finally{
             this.overlay = false
          }
    },

    closeModal (){
      this.produto = this.Defaultproduto
      this.$store.state.verdialogoemolumento = false
    }
    
  },
};
</script>

<style scoped>
.popup {
  position: fixed;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  transition: top 0.3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-content {
  background: #fff;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  width: 60%;
  margin-left: 200px;
}

.tabela-pagamento thead {
  background-color: #006699;
}

.tabela-pagamento th {
  color: #fff !important;
}
</style>
